/* global modForm modUtils */
import { switchFormLoadingState, showUtilityProviders } from '../../helpers';
/**
 * Get Electric Utility Providers by Zip
 * @param {String} zip - zip code
 * @param {Function} callback - callback function
 * @param {Boolean} showProviders - flag to call `showUtilityProviders()`
 */
export function getUtilityProvidersByZip(zip, callback, showProviders = true) {
	switchFormLoadingState(true);
	let response = {}, skipStep = false;
	const defaultResponse = {
		data: [
			{
				utilityProviderId: 999999,
				name: 'Other'
			}
		]
	};
	const request = new XMLHttpRequest();
	request.open('GET', modUtils.getApiDomain() + '/v1/lookups/utility-providers?filters[zip]=' + zip);
	request.send();
	request.addEventListener('load', function() {
		if (this.response) {
			response = { ...response, ...JSON.parse(this.response) };
			if (this.readyState === 4 && this.status === 200) {
				response.success = true;
				// if less than one utility provider is returned skip utility provider question
				if (response.success === true && response.data.length <= 1) {
					skipStep = true;
					const utilityProvider = document.createElement('input');
					utilityProvider.type = 'hidden';
					utilityProvider.name = 'utilityProviderId';
					utilityProvider.value = '999999';
					utilityProvider.setAttribute('data-required', 'nonempty');
					modForm.opts.form.append(utilityProvider);
				}
			} else {
				skipStep = true;
				response = defaultResponse;
			}
		}
	});

	request.addEventListener('error', function() {
		console.error('Something went wrong');
		skipStep = true;
		response = defaultResponse;
	});

	request.addEventListener('loadend', function() {
		if (showProviders) {
			showUtilityProviders(skipStep, response.data);
		}

		if ('function' === typeof callback) {
			callback(skipStep, response.data);
		}

		switchFormLoadingState(false);
	});
}
